// extracted by mini-css-extract-plugin
export default {"title":"Title_title__G4dcq","titleTag":"Title_titleTag__p4OlD"};